export default function VideoAE() {
  return (
    <>
      <section class="video-promo section bg-1">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="content-block">
                <h2>After Event YISF 2026</h2>
                <p></p>
                <a
                  data-fancybox
                  href="https://youtu.be/wo9SRnOKWxA?si=8TqlBu7UudsqfNzS"
                >
                  <i class="ti-control-play video"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
